import { Column } from "../objects/column";
import { Settlement } from "../objects/settlement";
import { SettlementErrors } from "../objects/settlementErrors";
import { SettlementListConfiguration } from "../objects/settlementListConfiguration";
import { SettlementListCriteria } from "../objects/settlementListCriteria";
import { SettlementListFiltersCriteria } from "../objects/settlementListFiltersCriteria";

export const EMPTY_SETTLEMENT: Settlement = {
    id: 0,
    code: "",
    type: "CLIENT",
    type_date: "INVOICE_DATE",
    delay_months: 0,
    delay_days: 0,
    first_call_delay: 0,
    second_call_delay: 0,
    day_of_the_week: -1,
    end_of_month: false,
    before_date: true,
    created_date: undefined,
    modified_date: undefined,
    creator: null,
    last_author: null,
    label: "",
    localization: [],
    custom_date: null
};

export const EMPTY_SETTLEMENT_FILTERS: SettlementListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_SETTLEMENT_LIST_CRITERIA: SettlementListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_SETTLEMENT_FILTERS,
    search: ''
};

export const EMPTY_SETTLEMENT_ERRORS: SettlementErrors = {
    code_error: "",
    due_date_error: "",
    trip_error: "",
    invoice_error: "",
    custom_date_error: ""
};

export const SETTLEMENT_INFO_ROUTE = '/central-payment/edit/:id/info';
export const SETTLEMENT_CONTACT_ROUTE = '/central-payment/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'code',
    field_name: 'CODE',
    checked: true,
    order_by: 'code',
    fixed_width: false,
    last_updated: false
}, {
    label: 'label',
    field_name: 'LABEL',
    checked: true,
    order_by: 'label',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];

export const EMPTY_SETTLEMENT_LIST_CONFIGURATION: SettlementListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const SETTLEMENT_MODULE = 'SETTLEMENT';
